/**
 * @generated SignedSource<<12f5e0615bf83b295b1e5a10e90fdfd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingTitleAndXWCSwitcher_viewer$data = {
  readonly account: {
    readonly id: string;
  };
  readonly " $fragmentType": "MeetingTitleAndXWCSwitcher_viewer";
};
export type MeetingTitleAndXWCSwitcher_viewer$key = {
  readonly " $data"?: MeetingTitleAndXWCSwitcher_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingTitleAndXWCSwitcher_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingTitleAndXWCSwitcher_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0d877e43e331b78ba99f024e0500f6ac";

export default node;
